import { createActionGroup } from '@ngrx/store';

export const ComposantTemplateActions = createActionGroup({
  source: 'Composant Template',
  events: {}
});
